import type { FC } from 'react';
import React from 'react';
import { Box } from '@edreamsodigeo/prisma-design-system';

interface AreaPreviewProps {
  x: number;
  y: number;
  w: number;
  h: number;
  bg: string;
}

const AreaPreview: FC<AreaPreviewProps> = ({ x, y, w, h, bg }) => (
  <Box
    position="absolute"
    left={`calc(100% * ${x})`}
    top={`calc(100% * ${y})`}
    width={`calc(100% * ${w})`}
    height={`calc(100% * ${h})`}
    backgroundColor={bg}
    border="1px solid rgba(0, 0, 0, 0.1)"
  />
);

export default AreaPreview;
